import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { formatAuditFieldName } from '@core/utils/auditLog';
import AuditLogValue from './AuditLogValue';

interface AuditLogChangesTableProps {
  changes: Record<string, { old: unknown; new: unknown }>;
}

const AuditLogChangesTable = ({ changes }: AuditLogChangesTableProps) => (
  <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
    <Table
      size="small"
      sx={{
        '& th, & td': { verticalAlign: 'top' },
        '& th:not(:last-of-type), & td:not(:last-of-type)': {
          borderRight: 1,
          borderColor: 'divider',
        },
        '& thead th': { fontWeight: 600 },
        '& thead th:first-of-type': { width: '30%' },
        '& thead th:nth-of-type(2)': {
          width: '35%',
          color: 'error.dark',
        },
        '& thead th:nth-of-type(3)': {
          width: '35%',
          color: 'success.dark',
        },
        '& tbody td:nth-of-type(2)': { color: 'error.dark' },
        '& tbody td:nth-of-type(3)': { color: 'success.dark' },
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell>Field</TableCell>
          <TableCell>Before</TableCell>
          <TableCell>After</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {Object.entries(changes).map(([field, { old, new: next }]) => (
          <TableRow key={field} hover>
            <TableCell>{formatAuditFieldName(field)}</TableCell>
            <TableCell>
              <AuditLogValue value={old} />
            </TableCell>
            <TableCell>
              <AuditLogValue value={next} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Paper>
);

export default AuditLogChangesTable;
